import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isWeightable(): boolean {
  const weightable = Number(localStorage.getItem("weightable"))
  return weightable ? Boolean(weightable) : false
}
